import React from 'react'
import '../Careers/Careers.css'
import Navbar from '../../Componect/Navbar/Navbar'
import FooterBottom from '../../Componect/Footer/FooterBottom'

const Careers = () => {
  return (
    <>
    <div className='Careers'>
    <Navbar></Navbar>
      <div className='CareersTxt'>
        <p>
          <h1>Jobs & Careers at স তে সতেরো</h1>
          <h3>Join Our Team!</h3>
          <p>At স তে সতেরো, we believe that great food and excellent service come from passionate individuals who love what they do. If you have a passion for hospitality, food, and customer service, we’d love to hear from you!
</p>

<h3>Why Work With Us?</h3>
<ul>
  <li>A friendly and professional work environment</li>
  <li>Opportunities for career growth and skill development</li>
  <li>Competitive salary and benefits</li>
  <li>A chance to work with an enthusiastic and dynamic team</li>
</ul>
<h3>Current Job Openings</h3>
<ul>
  <li>Restaurant Manager</li>
  <ul>
    <li>Location: Uttara, Dhaka</li>
    <li>Responsibilities:</li>
    <ul>
      <li>Oversee daily restaurant operations.</li>
      <li>Manage staff and ensure high-quality service.</li>
      <li>Maintain inventory and supplier relationships</li>
      <li>Handle customer feedback and improve service standards</li>
    </ul>
    <li>Requirements:</li>
    <ul>
      <li>2+ years / New of experience in restaurant management</li>
      <li>Strong leadership and communication skills</li>
    </ul>
  </ul>
  <li>Chef (Bangla & Continental Cuisine)</li>
  <ul>
    <li>Location: Uttara, Dhaka</li>
    <li>Responsibilities:</li>
    <ul>
      <li>Prepare delicious and high-quality meals</li>
      <li>Maintain kitchen hygiene and safety standards</li>
      <li>Innovate new dishes for the menu</li>
    </ul>
    <li>Requirements:</li>
    <ul>
      <li>Experience in Bangla and continental dishes</li>
      <li>Ability to work in a fast-paced kitchen</li>
    </ul>
  </ul>
  <li>Waiter/Waitress</li>
  <ul>
    <li>Location: Uttara, Dhaka</li>
    <li>Responsibilities:</li>
    <ul>
      <li>Provide excellent customer service</li>
      <li>Take and serve food orders</li>
      <li>Maintain cleanliness of dining areas</li>
    </ul>
    <li>Requirements:</li>
    <ul>
      <li>Prior experience is a plus but not required</li>
      <li>Friendly and energetic personality</li>
    </ul>
  </ul>
  <li>Barista</li>
  <ul>
    <li>Location: Uttara, Dhaka</li>
    <li>Responsibilities:</li>
    <ul>
      <li>Prepare and serve coffee and beverages</li>
      <li>Maintain cleanliness of the barista station</li>
      <li>Recommend drinks to customers</li>
    </ul>
    <li>Requirements:</li>
    <ul>
      <li>Experience in making coffee and beverages</li>
      <li>Passion for customer service</li>
    </ul>
  </ul>
  <li>Cashier</li>
  <ul>
    <li>Location: Uttara, Dhaka</li>
    <li>Responsibilities:</li>
    <ul>
      <li>Process customer payments accurately</li>
      <li>Manage daily cash transactions</li>
      <li>Assist with order processing</li>
    </ul>
    <li>Requirements:</li>
    <ul>
      <li>Basic knowledge of POS systems</li>
      <li>Good math and communication skills</li>
    </ul>
  </ul>
</ul>

<h3>How to Apply?</h3>
<p>If you’re interested in joining স তে সতেরো, please send your CV and cover letter to:</p>
<ul>
  <li>📧 Email: stesotero53@gmail.com</li>
  <li>📞 Contact: 01780-126370</li>
  <li>📍 Visit Us: Sector-17, Block-I, Road-10, Plot-26, Uttara, Dhaka</li>
</ul>
<p>We look forward to welcoming you to our team! 🎉</p>
</p>
      </div>
    <FooterBottom></FooterBottom>
    </div>
    
    </>
  )
}

export default Careers